import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Button, ButtonProps } from '@udemy-v2/react-core-components';
import { Icon } from '@udemy-v2/icons';
import { Loader } from '@udemy-v2/react-reveal-components';
import { useClpPrimaryCtaButton } from '@/features/course-landing-page/hooks/use-clp-primary-cta-button';
import { useCheckoutReferrer } from 'src/lib/hooks/use-checkout-referrer';
import { OneClickCheckoutButton } from '@/components/one-click-checkout-button';
import { useClpCourse } from '../../context/clp-course-provider.react-component';
export interface ClpPrimaryCtaButtonProps extends ButtonProps {
  /** Additional CSS class names */
  className?: string;
}
export const ClpPrimaryCtaButton: React.FC<ClpPrimaryCtaButtonProps> = t0 => {
  const $ = _c(35);
  let otherButtonProps;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      disabled: t1,
      size: t2,
      udStyle: t3,
      ...otherButtonProps
    } = t0);
    $[0] = t0;
    $[1] = otherButtonProps;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    otherButtonProps = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  const disabled = t1 === undefined ? false : t1;
  const size = t2 === undefined ? "large" : t2;
  const propsUdStyle = t3 === undefined ? "secondary" : t3;
  const {
    id,
    frontendTrackingId
  } = useClpCourse();
  const courseId = Number(id);
  const {
    saveCheckoutReferrer
  } = useCheckoutReferrer();
  const {
    text,
    checkoutUrl,
    trackEvent,
    isLoading,
    oneClickCheckoutContext,
    udStyle: hookUdStyle,
    iconName
  } = useClpPrimaryCtaButton();
  const udStyle = hookUdStyle ?? propsUdStyle;
  const isDisabled = disabled || !checkoutUrl || isLoading;
  let t4;
  if ($[5] !== checkoutUrl || $[6] !== isDisabled || $[7] !== saveCheckoutReferrer || $[8] !== trackEvent) {
    t4 = () => {
      if (isDisabled) {
        return;
      }
      trackEvent();
      saveCheckoutReferrer();
      window.location.assign(checkoutUrl);
    };
    $[5] = checkoutUrl;
    $[6] = isDisabled;
    $[7] = saveCheckoutReferrer;
    $[8] = trackEvent;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleClick = t4;
  let t5;
  if ($[10] !== iconName || $[11] !== isLoading || $[12] !== text) {
    t5 = () => {
      if (isLoading) {
        return <Loader color="inherit" overlay={true} />;
      }
      return <>{iconName && <Icon glyph={iconName} label={false} />}{text}</>;
    };
    $[10] = iconName;
    $[11] = isLoading;
    $[12] = text;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const renderButtonContent = t5;
  if (oneClickCheckoutContext?.isEnabled && courseId) {
    let t6;
    if ($[14] !== saveCheckoutReferrer || $[15] !== trackEvent) {
      t6 = () => {
        trackEvent();
        saveCheckoutReferrer();
      };
      $[14] = saveCheckoutReferrer;
      $[15] = trackEvent;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    let t7;
    if ($[17] !== courseId || $[18] !== frontendTrackingId || $[19] !== oneClickCheckoutContext || $[20] !== otherButtonProps || $[21] !== size || $[22] !== t6 || $[23] !== udStyle) {
      t7 = <OneClickCheckoutButton courseId={courseId} courseTrackingId={frontendTrackingId} size={size} udStyle={udStyle} onClick={t6} oneClickCheckoutContext={oneClickCheckoutContext} {...otherButtonProps} />;
      $[17] = courseId;
      $[18] = frontendTrackingId;
      $[19] = oneClickCheckoutContext;
      $[20] = otherButtonProps;
      $[21] = size;
      $[22] = t6;
      $[23] = udStyle;
      $[24] = t7;
    } else {
      t7 = $[24];
    }
    return t7;
  }
  let t6;
  if ($[25] !== renderButtonContent) {
    t6 = renderButtonContent();
    $[25] = renderButtonContent;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== handleClick || $[28] !== isDisabled || $[29] !== isLoading || $[30] !== otherButtonProps || $[31] !== size || $[32] !== t6 || $[33] !== udStyle) {
    t7 = <Button data-purpose="buy-now-button" disabled={isDisabled} onClick={handleClick} size={size} type="button" udStyle={udStyle} aria-busy={isLoading} {...otherButtonProps}>{t6}</Button>;
    $[27] = handleClick;
    $[28] = isDisabled;
    $[29] = isLoading;
    $[30] = otherButtonProps;
    $[31] = size;
    $[32] = t6;
    $[33] = udStyle;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  return t7;
};